<template>
  <kd-layout-fixed-bottom-button button-text="添加收货地址" @click="navToAddAddress" class="my-gift-address-page">
    <div class="address-list" v-if="addressList.length">
      <div class="address-card" v-for="(address, index) in addressList" :key="index">
        <div class="left">
          <div class="user-info">
            <div class="default-tag" v-if="address.default">默认</div>

            <div class="name">
              {{ address.name }}
            </div>
            <div class="phone">{{ address.phone }}</div>
          </div>
          <div class="address">{{ service.formatGifFullAddress(address) }}</div>
        </div>

        <div class="right" @click="navToEditAddress(address)">
          <img src="./assets/icon_edit@2x.png" class="edit" />
        </div>
      </div>
    </div>

    <div class="empty-box" v-else>
      <img src="./assets/img_empty_address@2x.png" />
      <div class="tip">还没有收货地址哦～</div>
    </div>
  </kd-layout-fixed-bottom-button>
</template>
<script lang="ts">
import { BasePage, Component } from 'kuaidong-component'
import { KdLayoutFixedBottomButton } from 'kuaidong-ui'
import { ITeacherAddressInfo } from 'kuaidong-model'
import { AGiftOrder } from 'kuaidong-api/src/AGiftOrder'
import { GiftOrderService } from 'kuaidong-service/src/GiftOrderService'
@Component({
  components: {
    KdLayoutFixedBottomButton,
  },
})
export default class MyGiftAddressPage extends BasePage {
  addressList: ITeacherAddressInfo[] = []
  get service() {
    return GiftOrderService
  }
  async created() {
    this.fetchTeacherAddressList()
  }

  async fetchTeacherAddressList() {
    this.addressList = await AGiftOrder.teacherAddressList()
  }

  navToAddAddress() {
    this.$router.push({
      name: 'add_gift_address',
    })
  }

  navToEditAddress(address: ITeacherAddressInfo) {
    this.$router.push({
      name: 'add_gift_address',
      query: {
        addressInfo: JSON.stringify(address),
      },
    })
  }
}
</script>
<style lang="less">
.kd-layout-fixed-bottom-button.my-gift-address-page {
  > .kd-layout-fixed-bottom__main {
    padding: 16px;
    > .address-list {
      display: flex;
      flex-direction: column;
      padding: 0 16px;
      background: #fff;

      > .address-card {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 16px 0;
        &:not(:last-of-type) {
          border-bottom: 1px solid #f5f5f5;
        }
        > .left {
          width: 275px;
          > .user-info {
            display: flex;
            > .default-tag {
              font-weight: 500;
              font-size: 10px;
              line-height: 10px;
              color: #3366ff;

              border: 1px solid #3366ff;
              border-radius: 2px;
              padding: 4px;
              margin-right: 8px;
            }
            > .name {
              font-weight: 500;
              font-size: 16px;
              line-height: 22px;
              color: #2d2f33;
              margin-right: 8px;
            }
            > .phone {
              font-weight: 400;
              font-size: 14px;
              line-height: 20px;
              color: #8f8f8f;
            }
          }
          > .address {
            margin-top: 18px;
            font-weight: 400;
            font-size: 14px;
            line-height: 131%;
            color: #4d4d4d;
            text-align: left;
          }
        }

        > .right {
          > img {
            width: 20px;
            height: 20px;
          }
        }
      }
    }

    > .empty-box {
      display: flex;
      flex-direction: column;
      > img {
        width: 105px;
        height: 105px;
        margin: 181px auto 0;
      }
      > .tip {
        font-weight: 400;
        font-size: 14px;
        line-height: 20px;
        text-align: center;
        color: #8f8f8f;
      }
    }
  }
}
</style>
